<template>
  <div>
    <a-list dense class="user-list" :height="screenHeight">   
      <v-list-item-group v-model="selectedItem" color="primary" mandatory>
        <template v-for="(user, index) in usersList">
          <v-list-item :key="user.id" :value="user.id">
            <v-list-item-avatar color="pageHeader">
               <v-img
                  v-if="
                    user.profilePhoto &&
                    user.profilePhoto != ''
                  "
                  :src="user.profilePhoto"
                  
                ></v-img>
                <v-img
                  v-else
                  src="@/assets/images/NoPhotoIcon.png"
                ></v-img>
            </v-list-item-avatar>

            <v-list-item-content style="padding-top: 3px;height: fit-content !important;">
              <v-list-item-title >
                <span v-if="user.firstName">
                  {{ user.firstName + " " + user.lastName }}
                </span>
                <span v-else>{{ user.registered_email }}</span>
              </v-list-item-title>
            <v-list-item-subtitle style="font-size:smaller;" v-if="user.firstName">
              {{ user.registered_email }}
            </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-divider
            v-if="index < usersList.length - 1"
            :key="index"
          ></v-divider>
        </template>
      </v-list-item-group>
    </a-list>
  </div>
</template>

<script>
import AList from "@/wrapper-component/AList.vue";
export default {
  name: "UserList",
  components: {
    AList
  },
  props: {
    value: {
      type: String,
      default: "",
    },
    usersList: Array,
    screenHeight: Number,
  },
  computed: {
    selectedItem: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value || null);
      },
    },
  },
 
};
</script>

<style scoped>
.user-list {

  overflow-y: auto;
  padding-top: 0px !important;
}

.in-person {
  color: var(--v-primary-base) !important;
}
.remotely {
  color: var(--v-warning-darken2) !important;
}
.absent {
  color: #bf360c !important;
}

.v-list--two-line .v-list-item,
.v-list-item--two-line {
  min-height: 54px;
}
</style>